document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-offer-countdown]').forEach(countdown=>{
    const output=countdown.querySelector('[data-countdown-time]');
    const cycleHours=Number(countdown.dataset.cycleHours)||48;
    const cycleMs=cycleHours*60*60*1000;
    const sharedEpoch=Date.UTC(2026,0,1,0,0,0);
    function updateCountdown(){
      const elapsed=Math.max(0,Date.now()-sharedEpoch);
      let remaining=cycleMs-(elapsed%cycleMs);
      const hours=Math.floor(remaining/3600000);
      remaining-=hours*3600000;
      const minutes=Math.floor(remaining/60000);
      remaining-=minutes*60000;
      const seconds=Math.floor(remaining/1000);
      if(output) output.textContent=[hours,minutes,seconds].map(value=>String(value).padStart(2,'0')).join(':');
    }
    updateCountdown();
    setInterval(updateCountdown,1000);
  });
  document.querySelectorAll('[data-rotating-announcement]').forEach(bar=>{
    const messages=[...bar.querySelectorAll('.announcement-message')];
    if(messages.length<2) return;
    let index=0;
    setInterval(()=>{
      messages[index].classList.remove('active');
      index=(index+1)%messages.length;
      messages[index].classList.add('active');
    },3000);
  });
  document.querySelectorAll('[data-product-root]').forEach(root=>{
    const radios=[...root.querySelectorAll('[data-variant-radio]')];
    const idInput=root.querySelector('[name="id"]');
    const price=root.querySelector('[data-price]');
    const compare=root.querySelector('[data-compare]');
    const buttons=[...document.querySelectorAll('[data-atc]')];
    function select(radio){
      radios.forEach(r=>r.closest('.bundle-card')?.classList.toggle('selected',r===radio));
      if(idInput) idInput.value=radio.value;
      if(price) price.textContent=radio.dataset.price;
      if(compare){compare.textContent=radio.dataset.compare||'';compare.hidden=!radio.dataset.compare}
      buttons.forEach(b=>{b.disabled=radio.dataset.available!=='true';b.textContent=radio.dataset.available==='true'?'ADD TO CART — FREE SHIPPING':'SOLD OUT'});
      document.querySelectorAll('[data-sticky-price]').forEach(el=>el.textContent=radio.dataset.price);
    }
    radios.forEach(r=>r.addEventListener('change',()=>select(r)));
    const checked=radios.find(r=>r.checked)||radios[0]; if(checked) select(checked);
    document.querySelectorAll('[data-sticky-add]').forEach(b=>b.addEventListener('click',()=>root.querySelector('form')?.requestSubmit()));
  });
  document.querySelectorAll('[data-thumb]').forEach(btn=>btn.addEventListener('click',()=>{
    const main=btn.closest('.gallery').querySelector('[data-main-image]');
    if(main){main.src=btn.dataset.src;main.srcset=''}
    btn.parentElement.querySelectorAll('[data-thumb]').forEach(x=>x.classList.remove('active'));btn.classList.add('active');
  }));
});
